import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useIframeMessaging } from './hooks/useIframeMessaging';
import i18next from 'i18next';
import { useSharedTokenInfo } from 'context/auth_context/TokenContext';
import jwt from 'jwt-decode';
import { useIframeMessageListener } from './hooks/useIframeMessageListener';

import clientConfig from 'client-config.js';

const iFrameOrigin = clientConfig.nextUrl; 

const NewAppIFrame = ({iFramePagePath, title }) => {
    // Turn on debug to see detailed message logs
    const missingUnitManagerMessages = useIframeMessageListener('missing-company-unit-data', { debug: true });

    const {authString} = useSharedTokenInfo();
    const userId = (authString || authString === "null") ? "":  jwt(authString).data.user.id;

    const [language, setLanguage] = useState(() => localStorage.getItem('preferredLanguage') || 'en');
    const [missingUnitManagerFields, setMissingUnitManagerFields] = useState(false);
    
    const iframeRef = useRef(null);
    const [isMounted, setIsMounted] = useState(false);

    const initialMessages = useMemo(() => [
        { type: 'userId', value: userId },
        { type: 'auth', value: authString },
        { type: 'language', value: language }, // Also send language initially
    ], [authString, language, userId]);

    const { handleLoad, sendMessage } = useIframeMessaging(iframeRef, iFrameOrigin, initialMessages, iFramePagePath, language);

    if (!authString || authString === 'null') {
        return null; 
    }    useEffect(() => {
        setIsMounted(true);
        const isMissingUnitManagerFields = localStorage.getItem('missingUnitManagerFields');
        if (isMissingUnitManagerFields === 'true') {
            setMissingUnitManagerFields(true);
        } else {
            setMissingUnitManagerFields(false);
        }
        return () => {
            setIsMounted(false);
        }
    }, []);
    
    
    useEffect (() =>{
        const handleLanguageChange = (lng) => {
            setLanguage(lng);
            // Send language update to iframe when it changes
            sendMessage('language', lng);
        };
        
        i18next.on('languageChanged', handleLanguageChange);
        
        // component unmounts -> removes only this specific listener.
        return () => {
            i18next.off('languageChanged', handleLanguageChange);
        };
    }, [sendMessage])
    

    useEffect(() => {
        // Handle missingUnitManagerMessages (can be true, false, or null before any message is received)
        const value = missingUnitManagerMessages?.missingUnitManagerFields;

        if (value === true) {
            localStorage.setItem('missingUnitManagerFields', 'true');
            setMissingUnitManagerFields(true);
        } else if (value === false) {
            localStorage.setItem('missingUnitManagerFields', 'false');
            setMissingUnitManagerFields(false);
        }
    }, [missingUnitManagerMessages]);


    if (!isMounted) {
        return null;
    }
    
    return (
        <>
            <iframe
                id='iframe-id'
                ref={iframeRef}
                src={`${iFrameOrigin}${language}/${iFramePagePath.includes('profile') && missingUnitManagerFields === true ? `/profile?missingUnitManagerFields=true` : iFramePagePath}`}
                style={{ width: '100%', height: '94dvh', border: 'none', overflow: 'hidden'}}
                onLoad={handleLoad}
                title={title}
                allow='clipboard-write'
            />
        </>
    );
};

export default NewAppIFrame;